import { useState, useEffect } from "react";
import Layout from "./Layout";
import {
  get_lost_found_list,
  update_lost_found_status,
  server_post_data,
} from "../ServiceConnection/serviceconnection.js";
import {
  handleError,
  handleSuccessShow,
} from "../CommonJquery/CommonJquery.js";
import Loader from "./Loader.js";

const LostFound = () => {
  const [lostFoundReports, setLostFoundReports] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedReport, setSelectedReport] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [updateForm, setUpdateForm] = useState({});

  const filteredReports = lostFoundReports.filter(
    (report) =>
      report.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      report.location.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const master_data_get = async () => {
    setIsLoading(true);
    let fd = new FormData();

    await server_post_data(get_lost_found_list, fd)
      .then((Response) => {
        if (Response.data.error) {
          setIsLoading(false);
          handleError(Response.data.message);
        } else {
          setLostFoundReports(Response.data.data);
          console.log(Response.data.data);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    master_data_get();
  }, []);

  const handleViewDetails = (report) => {
    setSelectedReport(report);
    setShowModal(true);
  };
  const handleUpdateStatus = (report) => {
    setSelectedReport(report);
    setShowUpdateModal(true);
  };
  const handleAssignCase = (report) => {
    setSelectedReport(report);
    setShowAssignModal(true);
  };

  const handleAssignToBooth = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    let fd = new FormData();
    fd.append("primary_id", selectedReport.primary_id);
    fd.append("flag", "1");
    fd.append("assign_to", updateForm.status);

    await server_post_data(update_lost_found_status, fd)
      .then((Response) => {
        if (Response.data.error) {
          setIsLoading(false);
          handleError(Response.data.message);
        } else {
          handleSuccessShow(Response.data.message);
          setIsLoading(false);
          setShowUpdateModal(false);
          setSelectedReport(null);
          setUpdateForm({});
          master_data_get();
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const handleupdateStatus = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    let fd = new FormData();
    fd.append("primary_id", selectedReport.primary_id);
    fd.append("flag", "0");
    fd.append("assign_to", "");

    await server_post_data(update_lost_found_status, fd)
      .then((Response) => {
        if (Response.data.error) {
          setIsLoading(false);
          handleError(Response.data.message);
        } else {
          handleSuccessShow(Response.data.message);
          setIsLoading(false);
          setShowUpdateModal(false);
          setSelectedReport(null);
          setUpdateForm({});
          master_data_get();
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  return (
    <>
      {isLoading && <Loader />}
      <Layout>
        <div className="page">
          <h2 className="page-title">Lost & Found Management</h2>

          <div className="search-bar">
            <input
              type="text"
              placeholder="Search by name or location..."
              className="search-input"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <div className="table-container">
            <table className="table">
              <thead>
                <tr className="table-header">
                  <th className="th">Sr.No.</th>
                  <th className="th">Type</th>
                  <th className="th">Name</th>
                  <th className="th">Age</th>
                  <th className="th">Description</th>
                  <th className="th">Photo</th>
                  <th className="th">Location</th>
                  <th className="th">Assigned To</th>
                  <th className="th">Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredReports.map((report, index) => (
                  <tr key={report.id} className="table-row">
                    <td className="td">{index + 1}</td>
                    <td className="td">
                      <span
                        className={`type-badge ${
                          parseInt(report.lost_or_found) === 0
                            ? "missing"
                            : "found"
                        }`}
                      >
                        {parseInt(report.lost_or_found) === 0
                          ? "Lost"
                          : "Found"}
                      </span>
                    </td>
                    <td className="td">{report.name}</td>
                    <td className="td">{report.age}</td>
                    <td className="td">
                      {report.description.length > 30
                        ? `${report.description.substring(0, 30)}...`
                        : report.description}
                    </td>
                    <td className="td">
                      <img
                        src={report?.img1 || "/placeholder.svg"}
                        alt="Person"
                        className="thumbnail"
                      />
                    </td>
                    <td className="td">{report.point_address}</td>
                    <td className="td">
                      {report.assign_to === ""
                        ? "Not Assigned"
                        : report.assign_to}
                    </td>
                    <td className="td">
                      <div className="action-buttons">
                        <button
                          className="action-button"
                          onClick={() => handleViewDetails(report)}
                        >
                          View
                        </button>
                        <button
                          className={`action-button success ${
                            report.assign_to === "" ? "" : "Disaled"
                          }`}
                          onClick={() => handleAssignCase(report)}
                        >
                          Assign To
                        </button>
                        <button
                          className={`action-button update-button ${
                            parseInt(report.lost_or_found) === 0
                              ? ""
                              : "Disaled"
                          }`}
                          onClick={() => handleUpdateStatus(report)}
                        >
                          Update Status
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Modal for viewing details */}
          {showModal && selectedReport && (
            <div className="modal-overlay" onClick={() => setShowModal(false)}>
              <div className="modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                  <h3>Report Details</h3>
                  <button
                    className="close-button"
                    onClick={() => setShowModal(false)}
                  >
                    ×
                  </button>
                </div>
                <div className="modal-content">
                  <img
                    src={selectedReport.photo || "/placeholder.svg"}
                    alt="Person"
                    className="modal-image"
                  />
                  <div className="modal-details">
                    <p>
                      <strong>Name:</strong> {selectedReport.name}
                    </p>
                    <p>
                      <strong>Age:</strong> {selectedReport.age}
                    </p>
                    <p>
                      <strong>Status:</strong>{" "}
                      {parseInt(selectedReport.lost_or_found) === 0
                        ? "Lost"
                        : "Found"}
                    </p>
                    <p>
                      <strong>Assigned To:</strong>
                      {selectedReport.assign_to === ""
                        ? "Not Assigned"
                        : selectedReport.assign_to}
                    </p>
                    <p>
                      <strong>Description:</strong> {selectedReport.description}
                    </p>
                    <p>
                      <strong>Point Address:</strong>{" "}
                      {selectedReport.point_address}
                    </p>
                    <p>
                      <strong>Location:</strong>{" "}
                      <a
                        href={`https://www.google.com/maps?q=${selectedReport.lat},${selectedReport.long}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 underline"
                      >
                        {selectedReport.lat}, {selectedReport.long}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Update Modal */}
          {showUpdateModal && selectedReport && (
            <div
              className="modal-overlay"
              onClick={() => setShowUpdateModal(false)}
            >
              <div className="modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                  <h3>Change Status</h3>
                  <button
                    className="close-button"
                    onClick={() => setShowUpdateModal(false)}
                  >
                    ×
                  </button>
                </div>
                <form>
                  <div className="modal-content">
                    <div className="form-group">
                      <label className="label">Status:</label>
                      <select
                        className="select"
                        defaultValue={
                          updateForm?.lost_or_found ||
                          selectedReport?.lost_or_found
                        }
                        onChange={(e) =>
                          setUpdateForm({
                            ...updateForm,
                            status: e.target.value,
                          })
                        }
                      >
                        <option value="0">Lost</option>
                        <option value="1">Found</option>
                      </select>
                    </div>
                  </div>
                  <div className="modal-actions">
                    <button
                      type="submit"
                      className="modal-button"
                      onClick={handleupdateStatus}
                    >
                      Update
                    </button>
                    <button
                      type="button"
                      className="modal-button secondary"
                      onClick={() => setShowUpdateModal(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

          {/* Asign Modal */}
          {showAssignModal && selectedReport && (
            <div
              className="modal-overlay"
              onClick={() => setShowAssignModal(false)}
            >
              <div className="modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                  <h3>Change Status</h3>
                  <button
                    className="close-button"
                    onClick={() => setShowAssignModal(false)}
                  >
                    ×
                  </button>
                </div>
                <form>
                  <div className="modal-content">
                    <div className="form-group">
                      <label className="label">Status:</label>
                      <select
                        className="select"
                        defaultValue={
                          updateForm?.lost_or_found ||
                          selectedReport?.lost_or_found
                        }
                        onChange={(e) =>
                          setUpdateForm({
                            ...updateForm,
                            status: e.target.value,
                          })
                        }
                      >
                        <option value="Booth 1">Booth 1</option>
                        <option value="Booth 2">Booth 2</option>
                        <option value="Police">Police</option>
                      </select>
                    </div>
                  </div>
                  <div className="modal-actions">
                    <button
                      type="submit"
                      className="modal-button"
                      onClick={handleAssignToBooth}
                    >
                      Update
                    </button>
                    <button
                      type="button"
                      className="modal-button secondary"
                      onClick={() => setShowAssignModal(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </Layout>
    </>
  );
};

export default LostFound;
